"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs
 * API documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfSigninDto = instanceOfSigninDto;
exports.SigninDtoFromJSON = SigninDtoFromJSON;
exports.SigninDtoFromJSONTyped = SigninDtoFromJSONTyped;
exports.SigninDtoToJSON = SigninDtoToJSON;
exports.SigninDtoToJSONTyped = SigninDtoToJSONTyped;
/**
 * Check if a given object implements the SigninDto interface.
 */
function instanceOfSigninDto(value) {
    if (!('email' in value) || value['email'] === undefined)
        return false;
    if (!('password' in value) || value['password'] === undefined)
        return false;
    return true;
}
function SigninDtoFromJSON(json) {
    return SigninDtoFromJSONTyped(json, false);
}
function SigninDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'email': json['email'],
        'password': json['password'],
    };
}
function SigninDtoToJSON(json) {
    return SigninDtoToJSONTyped(json, false);
}
function SigninDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'email': value['email'],
        'password': value['password'],
    };
}
